// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__egwqz","rootInnerPage":"Header_rootInnerPage__eQ_fj"};